import DeleteOutlinedIcon from '@mui/icons-material/DeleteOutlined'
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined'
import MoreVertIcon from '@mui/icons-material/MoreVert'
import IconButton from '@mui/material/IconButton'
import ListItemText from '@mui/material/ListItemText'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Typography from '@mui/material/Typography'
import * as React from 'react'
import { ProjectArchiveDialog } from '../../../../dialogs/ProjectArchiveDialog/ProjectArchiveDialog'
import { ProjectDeleteDialog } from '../../../../dialogs/ProjectDeleteDialog/ProjectDeleteDialog'
import { ProjectRenameDialog } from '../../../../dialogs/ProjectRenameDialog/ProjectRenameDialog'
import { useAssistantAdministrationStore } from '../../../../store/storeAssistantAdministration'
import PenIcon from './../../../../assets/icons/PenIcon.svg?react'

export const ProjectItemMenu = ({ workplaceDetail }) => {
    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
    const [openRemoveDialog, setOpenRemoveDialog] = React.useState<boolean>(false)
    const [openArchiveDialog, setOpenArchiveDialog] = React.useState<boolean>(false)
    const [openRenameDialog, setOpenRenameDialog] = React.useState<boolean>(false)
    const open = Boolean(anchorEl)
    const { setIdActiveEditRecord } = useAssistantAdministrationStore((state) => state)

    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget)
    }
    const handleClose = () => {
        setIdActiveEditRecord(undefined)
        setOpenRemoveDialog(false)
        setOpenArchiveDialog(false)
        setOpenRenameDialog(false)
        setAnchorEl(null)
    }

    const handleClickOpenRemoveDialog = () => {
        setOpenRemoveDialog(true)
    }

    const handleClickOpenArchiveDialog = () => {
        setOpenArchiveDialog(true)
    }

    return (
        <>
            <IconButton
                sx={{
                    mr: 1,
                    '&:hover': { borderColor: '#F4F4F6' },
                    background: '#F9FAFB',
                    zIndex: 1000,
                }}
                variant="text"
                color="primary"
                aria-expanded={open ? 'true' : undefined}
                onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                MenuListProps={{
                    'aria-labelledby': 'basic-button',
                }}>
                {!workplaceDetail.is_archived && (
                    <MenuItem onClick={() => setOpenRenameDialog((prev) => !prev)}>
                        <ListItemText
                            primary={<Typography variant="body">Редактировать</Typography>}
                        />
                        <PenIcon />
                    </MenuItem>
                )}

                {!workplaceDetail.is_protected && (
                    <MenuItem onClick={handleClickOpenArchiveDialog}>
                        <ListItemText
                            primary={
                                <Typography variant="body">
                                    {workplaceDetail.is_archived
                                        ? 'Разархивировать'
                                        : 'Архивировать'}
                                </Typography>
                            }
                        />
                        <Inventory2OutlinedIcon fontSize="small" />
                    </MenuItem>
                )}

                <MenuItem onClick={handleClickOpenRemoveDialog}>
                    <ListItemText
                        primary={
                            <Typography variant="body" style={{ color: '#CA1616' }}>
                                Удалить
                            </Typography>
                        }
                    />
                    <DeleteOutlinedIcon fontSize="small" style={{ color: '#CA1616' }} />
                </MenuItem>
            </Menu>
            {openArchiveDialog && workplaceDetail && (
                <ProjectArchiveDialog
                    open={openArchiveDialog}
                    handleClose={handleClose}
                    workplaceDetail={workplaceDetail}
                />
            )}
            {openRemoveDialog && workplaceDetail && (
                <ProjectDeleteDialog
                    open={openRemoveDialog}
                    handleClose={handleClose}
                    id={workplaceDetail.id}
                />
            )}
            <ProjectRenameDialog
                open={openRenameDialog}
                handleClose={handleClose}
                workplaceDetail={workplaceDetail}
            />
        </>
    )
}
